/***
 * File name: subtable.js
 *
 * Program Description:
 * This file contains all the meta configuration of the Specific Casues table in
 * the Cause of Incident master data.
 *
 * Includes the ff:
 * - Name, collection name, label and other static values for the table
 * - Data view for fetching different formatted data from the server
 * - Route definitions for different actions within the table
 * - binded varibles
 * - Advanced query when fetching data list
 * - Name of the privilege for role restrictions
 * - Name of table columns indicated as fields
 * - Action buttons on top of the table indicated as tableActions
 * - Action buttons per item inside the table indicated as entryActions
 * - Breadcrumbs definition
 *
 */
export default function (vm) {
  return {
    name: 'SpecificCauseTable',
    collectionName: 'causeOfIncident',
    dataView: 'default',
    label: 'Specific Cause',
    tableHeader: 'Specific Causes',
    route: {
      updateMultiple: 'causeOfIncident',
      list: 'causeOfIncident',
      deleteMultiple: 'causeOfIncident',
      upload: 'causeOfIncident'
    },
    advancedQuery: {
      jurisdiction: vm.itemSelected
    },
    vBind: {
      singleSelect: true
    },
    // listFilter: (list) => {
    //   list.filter(x => x.jurisdiction === vm.itemSelected)
    // },
    hideSelect: true,
    privilege: 'canViewAllCauseOfIncident',
    fields: [
      {
        columnHeader: {
          sortable: true,
          text: 'Specific Cause',
          value: 'value'
        }
      }
    ],
    tableActions: [
      {
        id: 'create',
        label: 'Add',
        icon: 'mdi-plus',
        color: 'white',
        vBind: {
          style: vm.itemSelected === 'xxx' ? '' : 'background-color: #162b54',
          disabled: vm.itemSelected === 'xxx'
        },
        privilege: 'canPostCauseOfIncident',
        action: () => {
          vm.$emit('modalChange', 'create', 'specific')
        }
      }
    ],
    entryActions: [
      {
        id: 'view',
        icon: 'mdi-eye',
        privilege: 'canViewCauseOfIncident',
        action: (item) => {
          vm.$emit('modalChange', 'view', 'specific', item._id)
        }
      },
      {
        id: 'edit',
        icon: 'mdi-pencil',
        privilege: 'canViewCauseOfIncident',
        action: (item) => {
          vm.$emit('editRow', 'edit', 'specific', item._id)
        }
      },
      {
        id: 'del',
        icon: 'mdi-delete',
        privilege: 'canDeleteCauseOfIncident',
        action: (item) => {
          vm.$emit('deleteRow', 'delete', 'specific', item._id)
        }
      }
    ],
    breadcrumbs: {
      divider: '/',
      large: true,
      items: [
        {
          text: 'Specific Cause'
        }
      ]
    }
  }
}
